<dialog-gala (clickClose)="hideModal()">
    <span gala-dialog-titre>{{boEnvoi ? lgTrad.ENVOYER : lgTrad.EXPORTDOC }}</span>
    @if (formDoc) {
    <form [formGroup]="formDoc" autocomplete="off">
        <div>
            <select-gala formControlName="TYPEDOC" [options]="listeDocEnvoi" [label]="lgTrad.DOCUMENT" bindLabel="LIB"
                (selected)="onDocChange($event)" />
            <!--<select-gala *ngIf="boEnvoi" formControlName="DESTINATAIRE" [options]="listeDestinataire" [label]="lgTrad.DESTINATAIRE" bindLabel="LIB" [searchable]="true" (selected)="selectDest($event)"></select-gala>-->
            @if (boEnvoi) {
            <div class="row">
                <div class="col-12">
                    <div class="input-group">
                        <select-gala formControlName="DESTINATAIRE" [label]="lgTrad.DESTINATAIRE"
                            [options]="listeDestinataire" [selectedItem]="formDoc.getRawValue().DESTINATAIRE"
                            [choixMultiple]="true" [hideSelected]="true" bindLabel="LIB"
                            [bindLabelAsTemplate]="destinataire" [searchable]="true" (selected)="selectDest($event)">
                            <ng-template #destinataire let-item="item" let-clear="clear">
                                <span class="ng-value-label">
                                    @if (isReferent(item) || isContact(item)) {
                                    &#11088;
                                    }
                                    {{item.LIB}}
                                    @if (!hasEmail(item)){
                                    <i class="fas fa-envelope text-red"></i>
                                    }
                                </span>
                                @if (formDoc.controls.DESTINATAIRE?.value?.includes(item)){
                                <span class="ng-value-icon right" (click)="removeItem(item)" aria-hidden="true">×</span>
                                }
                            </ng-template>
                        </select-gala>
                    </div>
                </div>
            </div>
            }
            @if (boEnvoi) {
            <select-gala formControlName="TYPENVOI" [options]="listeTEnvoi" [label]="lgTrad.ENVOITYPE"
                bindLabel="LIB" />
            }
        </div>
    </form>
    <select-gala [options]="listeTypesFichiers" [label]="lgTrad.FORMAT" [(ngModel)]="selectTypeFichier"
        bindValue="value" />
    }
    <div gala-dialog-actions>
        <button mat-stroked-button color="primary" (click)="saveDocument()">{{boEnvoi ? lgTrad.ENVOYER :
            lgTrad.TELECHARGER}}</button>
        <button mat-stroked-button color="accent" (click)="hideModal()">{{lgTrad.CANCEL}}</button>
    </div>
</dialog-gala>